import {getRomanNumber} from "utils/functions";
import {useAuth} from "hooks/useAuth";
import Typography from "@mui/material/Typography";

interface IDMessageTitle {
    subject: string;
    name?: string;
    mode: number;
    classroom: string;
    classroom_grade: number;
    type: string;
    file: {fileName: string, filePath: string} | null;
}

const MessageTitle = (data: IDMessageTitle) => {
    const {user} = useAuth();
    const getModeText = (mode: number) => {
        if (mode === 2) return "de antrenament";
        if (mode === 7 && user.position === "student") return "propriu"; else if (mode === 7 && user.position === "teacher") return "proprii";
        return "";
    };

    const getSubjectText = (mode: number, subject: string) => {
        return mode === 5 ? "Literație" : subject;
    };

    const renderContent = () => {
        switch (data.type) {
            case 'TEST_SESSION_CLOSED':
                return user.position === "teacher" ? "Finalizare test" : null;

            case 'USER_CREATED':
                return "Bine ai venit pe Brio.ro!";

            case 'TEST_SESSION_EXPIRED':
                if (user.position === "student") return "Sesiunea de testare a expirat.";
                if (user.position === "teacher") return "Sesiunile de testare au expirat.";
                return null;

            case 'TEST_SESSION_CREATED':
                const modeText = getModeText(data.mode);
                const typeText = getSubjectText(data.mode, data.subject);

                if (user.position === "student") {
                    return `Profesorul ${data.name} ți-a generat un test ${modeText ? modeText + " " : ""}de ${typeText}`;
                }
                if (user.position === "teacher") {
                    const romanGrade = data.classroom_grade ? ` (${getRomanNumber(data.classroom_grade)})` : "";
                    return `Testele ${modeText ? modeText + " " : ""}de ${typeText} pentru${romanGrade} ${data.classroom} au fost generate`;
                }
                return null;

            case 'TEST_SESSION_STARTED':
                return user.position === "teacher" ? "Accesare test" : null;

            case 'EXPORT_CREATED':
                return <>Fișierul <i>{data.file?.fileName}</i> poate fi descărcat</>;

            default:
                return null;
        }
    };

    return <>{renderContent()}</>;
};

export default MessageTitle;
